import { useEffect, useState } from "react";

export function useMediaQuery(query: string): boolean {
	const [matches, setMatches] = useState(() => {
		if (typeof window === "undefined") return false;
		return window.matchMedia(query).matches;
	});

	useEffect(() => {
		const mql = window.matchMedia(query);
		const handler = (e: MediaQueryListEvent) => setMatches(e.matches);
		mql.addEventListener("change", handler);
		setMatches(mql.matches);
		return () => mql.removeEventListener("change", handler);
	}, [query]);

	return matches;
}

export function useIsMobile() {
	return useMediaQuery("(max-width: 640px)");
}

export function useIsTablet() {
	return useMediaQuery("(min-width: 641px) and (max-width: 1024px)");
}

export function useIsDesktop() {
	return useMediaQuery("(min-width: 1025px)");
}

export function useReducedMotion() {
	return useMediaQuery("(prefers-reduced-motion: reduce)");
}
